<template>
  <div id="user-created" class="section">
    <div class="columns is-flex-direction-column">
      <div class="column is-half-desktop is-offset-one-quarter-desktop">
        <h2 class="subtitle">会員登録</h2>
        <p class="block">
          この度は、「Pandora」にご登録いただきありがとうございます。
          <br />
          ご登録のメールアドレスに認証メールをお送りしました。認証メールに記載されたURLにアクセスいただき、登録を完了させてください。
        </p>
        <p class="block">
          メールが届いてない場合は、<a
            class="resend-btn"
            @click="resendVerificationMail"
          >
            こちら</a
          >を押して再発送のリクエストをしてください。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import * as authServices from '@/services/authServices';

export default {
  name: 'UserCreated',
  methods: {
    async resendVerificationMail() {
      await authServices
        .getFirebaseUser()
        .sendEmailVerification()
        .catch(err => {
          alert(
            '[Error] Can not send mail',
            `${
              authServices.getFirebaseUser().email
            }宛に確認メールを送信できませんでした: ${err}`
          );
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/user-created.scss';
</style>
